import { theme } from "../../styles/styles"

export const spaceDivider = `<p style="font-family: sans-serif; font-size: 14px; font-weight: normal; margin: 0; margin-bottom: 15px; height: 15px;"></p>`

export const generateEmailParagraph = (content: string, additionalStyle?: string) =>
  `<p style="font-family: sans-serif; font-size: 14px; font-weight: normal; margin: 0; margin-bottom: 15px; ${
    additionalStyle ? additionalStyle : ""
  }">${content}</p>`

export const generateEmailText = (content: string) => `<p style="font-family: sans-serif; font-size: 14px; font-weight: normal; margin: 0;">${content}</p>`

//TODO
export const generateEmailHeading2 = (content: string, url?: string, additionalStyle?: string) => `
<div style="font-family:Ubuntu, Helvetica, Arial, sans-serif;font-size:13px;line-height:1.5;text-align:left;color:#000000;"><h2 style="font-family: Roboto, Tahoma, sans-serif; font-size: 17px; color: #444444; ${
  additionalStyle ? additionalStyle : ""
}"><span style="color: ${theme.colors["main-color-blue"]}; text-decoration: none;">${
  url ? `<a style="color: ${theme.colors["main-color-blue"]}; text-decoration: none;" href="${url}">${content}</a>` : content
}</span></h2></div>
`

export const generateEmailHeading3 = (content: string, url: string) => `
<div style="font-family:Ubuntu, Helvetica, Arial, sans-serif;font-size:12px;line-height:1.4;text-align:left;color:#000000;"><h3 style="font-family: Roboto, Tahoma, sans-serif; font-size: 15px; color: #444444; text-decoration: none;"><span style="color: ${theme.colors["main-color-blue"]};"><a style="color: ${theme.colors["main-color-blue"]}; text-decoration: none;" href="${url}">${content}</a></span></h3></div>
`

export const generateEmailTableRow = (content: string) => `<tr>
                                                            <td style="font-family: sans-serif; font-size: 14px; vertical-align: top;">
                                                                ${content}
                                                            </td>
                                                           </tr>`

export const generateEmailTable = (
  content: string
) => `<table border="0" cellpadding="0" cellspacing="0" style="border-collapse: separate; mso-table-lspace: 0pt; mso-table-rspace: 0pt; width: 100%; box-sizing: border-box;">
                                            <tbody>
                                            <tr>
                                                <td align="left" style="font-family: sans-serif; font-size: 14px; vertical-align: top; padding-bottom: 15px;">
                                                    <table border="0" cellpadding="0" cellspacing="0" style="border-collapse: separate; mso-table-lspace: 0pt; mso-table-rspace: 0pt; width: auto;">
                                                        <tbody>
                                                        ${content}
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>`

export const generateEmailCallToActionButton = (
  title: string,
  content: string,
  href: string,
  withoutMargin?: boolean
) => `<table border="0" cellpadding="0" cellspacing="0" class="btn btn-primary" style="border-collapse: separate; mso-table-lspace: 0pt; mso-table-rspace: 0pt; width: 100%; box-sizing: border-box;">
                                            <tbody>
                                            <tr>
                                                <td align="left" style="font-family: sans-serif; font-size: 14px; vertical-align: top; padding-bottom: ${
                                                  withoutMargin ? "0" : "15px"
                                                };">
                                                    <table border="0" cellpadding="0" cellspacing="0" style="margin: 0 auto; border-collapse: separate; mso-table-lspace: 0pt; mso-table-rspace: 0pt; width: auto;">
                                                        <tbody>
                                                        ${
                                                          title && content
                                                            ? `<tr>
                                                                    <td style="font-family: sans-serif; font-size: 14px; vertical-align: top; background-color: ${theme.colors["main-color-blue"]}; border-radius: 20px; text-align: center;">
                                                                        <a href="${href}" target="_blank" style="display: inline-block; color: #ffffff; background-color: ${theme.colors["main-color-blue"]}; border: solid 1px ${theme.colors["main-color-blue"]}; border-radius: 20px; box-sizing: border-box; cursor: pointer; text-decoration: none; font-size: 14px; margin: 0; padding: 5px 15px; border-color: ${theme.colors["main-color-blue"]};" title="${title}">
                                                                            ${content}
                                                                        </a>
                                                                    </td>
                                                                </tr>`
                                                            : ""
                                                        }
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>`
